export default class CBAA1020RequestModel {
  rkPlnCd: string
}
